import { useMutation } from '@tanstack/react-query'
import { DeleteAdvertiserParams, deleteAdvertiser } from 'supabase/advertisers'
import { queryClient } from 'utils'

export const useDeleteAdvertiser = (onSuccess: () => void) => {
  const mutation = useMutation({
    mutationFn: (params: DeleteAdvertiserParams) => {
      return deleteAdvertiser(params)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['advertisers'],
      })
      onSuccess()
    },
  })

  return mutation
}